import React from "react";
import {
	FleetInfoResponse
} from "services/utils/interfaces"; 
import "./InfoSection.less";
import { Tag, Collapse } from "antd";
import useWindowDimensions from "../../../../common/functions";
import i18n from "i18next";

type Props = {
	data: FleetInfoResponse | any,
	shouldRefresh: boolean,
	fleetId: string,
	status: string
};

const { Panel } = Collapse;

const InfoSection:React.FC<Props> = ({
	data,
	status
}):React.ReactElement => {

	const getStatus = () => {
		let color = "#CECECE";
		if (status === "Plugged-in") {
      color = "#9DCC78";
    }
		return <Tag className="tag" color={color} key={status}>{status.toUpperCase()}
			</Tag>;
	};

	const {width} = useWindowDimensions();
	const dataUpdated = {};
	Object.keys(data).forEach(key => {
		if (key === "make") {
			dataUpdated[i18n.t("fleet.make")] = data[key];
		} else if (key === "model") {
			dataUpdated[i18n.t("fleet.model")] = data[key]
		} else if (key === "year") {
			dataUpdated[i18n.t("fleet.year")] = data[key];
		} else if (key === "licensePlateNum") {
			dataUpdated[i18n.t("fleet.licensePlateNum")] = data[key];
		} else if (key === "EVID") {
			dataUpdated[i18n.t("fleet.EVID")] = data[key];
		} else if (key === "VIN") {
			dataUpdated[i18n.t("fleet.VIN")] = data[key];
		}
	});

	return (
		<>
			{
				width > 768 && data ? (
					<>
						<section className="fleet-info-header">
							<div className="fleet-Id">
								{data.vehicleId}
							</div>
							<div className="fleet-status">
								{getStatus()}
							</div>
						</section>

						<section className="get-fleet-info-content">
							{Object.keys(dataUpdated).map(key => {
									return (<section key={key} className="info-card">
										<div className="key">
											{key}
										</div>
										<div className="property">
											{dataUpdated[key]}
										</div>
									</section>);
							})}
						</section>
					</>
				) : (data ?  (
					<>
						<section className="fleet-info-header">
							<div className="fleet-Id">
								{data.vehicleId}
							</div>
							<div className="fleet-status">
								{getStatus()}
							</div>
						</section>

						<Collapse defaultActiveKey={["1"]} >
							{Object.keys(dataUpdated).map(key => {
								return (
									<Panel header={key} key={key}>
										<p>{dataUpdated[key]}</p>
									</Panel>
							);
							})}
						</Collapse>
					</>
				) : null)
			}
		</>
	);
};

export default InfoSection;
